const state = {
  notes: [],
  loading: false,
  error: null,

  noteWindowWidth: null,
  noteWindowHeight: null,
};

export default state;
